import React, { useState } from 'react'
import styled from 'styled-components'
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import moment from 'moment';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Tab, Tabs } from '@mui/material';
import LogoDevIcon from '@mui/icons-material/LogoDev';

import AceEditor from 'react-ace';
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/theme-monokai";

const TimelineItemContainer = styled.div`
  background-color: #ffffff;
  width: 500px;
  margin-top: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  border-left: 2px solid #212121;
  padding-right: 8px;

  .box {
    padding: 16px;
    display: flex;
    flex-direction: row;
    font-size: 13px;
    flex: 1;
    width: 500px;
  }

  .color {
    width: 8px;
    background-color: #673AB7;
    border-radius: 4px;
  }

  .icon {
    padding-left: 16px;
    padding-right: 32px;
  }

  .title {
    font-size: 14px;
  }

  .title, .footer {
    font-weight: bold;
    margin-bottom: 8px;
  }

  .footer {
    margin-top: 8px;
    font-size: 11px;
  }
`

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-xml-dialog-tabpanel-${index}`}
      aria-labelledby={`simple-xml-dialog-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div style={{ paddingTop: 16, paddingBottom: 16 }}>
          {children}
        </div>
      )}
    </div>
  );
}


function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-xml-dialog-tabpanel-${index}`,
  };
}

const TimelineItem = (props) => {
  const { item } = props
  const [openDialogXML, setOpenDialogXML] = useState(false)
  const [valueTabXML, setValueTabXML] = useState(0)
  const handleChange = (event, newValue) => {
    setValueTabXML(newValue);
  };

  return (
    <TimelineItemContainer>
      <div className='dot'></div>
      <div className='box'>
        {/* <div className='color'></div> */}
        <div className='icon'>
          <PointOfSaleIcon />
        </div>
        <div>
          <div className='title'>{item.TipoTimeline.nome}</div>
          <div className='description'>{item.descricao}</div>
          <div style={{display: 'flex', flexDirection: 'row'}}>
            {item.xmlRetorno ? <IconButton size='small' onClick={() => setOpenDialogXML(true)}>
              <LogoDevIcon />
            </IconButton> : ''}
            <div style={{flex: 1}}></div>
            {item.Usuario ? 
            <div className='footer'>{`${item.Usuario.nome} - ${moment(item.createdAt, "YYYY-MM-DDTHH:mm:ssZ").format("DD/MM/YYYY HH:mm:ss")}`}</div>:
            <div className='footer'>{`${moment(item.createdAt, "YYYY-MM-DDTHH:mm:ssZ").format("DD/MM/YYYY HH:mm:ss")}`}</div>}
          </div>
        </div>
      </div>

      <Dialog
        open={openDialogXML}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={800}>
        <DialogTitle id="alert-dialog-title">
          Logs
        </DialogTitle>
        <DialogContent style={{width: 800}}>
          <DialogContentText id="alert-dialog-description">

            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={valueTabXML} onChange={handleChange}>
                <Tab label="ENVIO" {...a11yProps(0)} />
                <Tab label="RETORNO" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <TabPanel value={valueTabXML} index={0}>
              <AceEditor
                mode="javascript"
                width="100%"
                height="300px"
                theme="monokai"
                value={item.xmlEnvio ? item.xmlEnvio : ''}
                showPrintMargin={true}
                showGutter={true}
                highlightActiveLine={true}
              />
            </TabPanel>
            <TabPanel value={valueTabXML} index={1}>
              <AceEditor
                mode="javascript"
                width="100%"
                height="300px"
                theme="monokai"
                value={item.xmlRetorno ? item.xmlRetorno : ''}
                showPrintMargin={true}
                showGutter={true}
                highlightActiveLine={true}
              />
            </TabPanel>
            
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialogXML(false)}>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </TimelineItemContainer>
  )
}


export default TimelineItem